<div class="my-overlay" *ngIf="showOverlay">
    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
</div>
<router-outlet> </router-outlet>
<app-loader></app-loader>